export default __webpack_public_path__ + "914238fdcb8357e6cd27d2b3dba0aefb.wav";